import { Dialog, RegisterRouter } from "@components";
import { ApplicationLayout, Sidebar } from "@rio-cloud/rio-uikit";
import { CreateAreaReworkPayload, IRoute, ISendRouteParams, IVehicleInfo, Route } from "@types";
import { useNavigate } from "react-router-dom";
import { CreateRouteCostPayload } from "../../types/costSimulator";
import { IDinamicSmartRoutePreferences } from "../Dynamics/DinamicSmartRoutePreferences";
import { IStop } from "../RegisterRoute";
import { useState } from "react";
import { useAppSelector, defineRouteName } from "@store";
import { useDispatch } from "react-redux";

type TProps = {
  sendRoute: (data: ISendRouteParams) => void;
  handleRoutes: (routes: Route[], via: any[]) => void;
  trip?: boolean;
  handleCustom?: (s: boolean) => void;
  isCustom?: boolean;
  handleEditDriverTrip?: () => void;
  handleEditVehicleTrip?: () => void;
  isEditTrip?: boolean;
  content: number;
  onContent?: (idx?: number) => void;
  skipChangeRoute?: React.MutableRefObject<boolean>;
};

const UpdateSidebarRoute = ({
  sendRoute,
  handleRoutes,
  trip,
  handleCustom,
  isCustom = false,
  isEditTrip,
  handleEditDriverTrip,
  handleEditVehicleTrip,
  content,
  onContent,
  skipChangeRoute,
}: TProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [disableConfirm, setDisableConfirm] = useState(false);
  const [name, setName] = useState('');
  const [payload, setPayload] = useState<ISendRouteParams>();
  const { routeId } = useAppSelector((state) => state.routes);
  const dispatch = useDispatch();

  const handleClose = () => {
    setShowDialog(false);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!payload) {
      return;
    }

    dispatch(defineRouteName(name));

    sendRoute({
      ...payload,
      value: name,
    });
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value)
    setEnableSubmit(Boolean(event.currentTarget.value));
  }

  const handleSave = (
    origin: IRoute,
    destination: IRoute,
    routes: Route[],
    stops: IStop[],
    routeName: string,
    routeCost: CreateRouteCostPayload,
    accountId: string,
    routeRangeToleranceLimit: number | null,
    avoidToll: boolean,
    areas: CreateAreaReworkPayload[],
    vehicle: IVehicleInfo,
    areasSelectedIds: string[],
    distance?: string,
    smartRoutePreference?: IDinamicSmartRoutePreferences,
    selectedFuelOption?: string | number,
  ) => {
    const mounted = {
      origin,
      destination,
      routes,
      stops,
      value: routeName,
      routeCost,
      accountId,
      avoidToll,
      areas,
      vehicle,
      areasSelectedIds,
      routeRangeToleranceLimit,
      smartRoutePreference,
      distance,
      selectedFuelOption,
    }

    if (!routeName && !routeId) {
      setPayload(mounted)
      setShowDialog(true);
      return;
    }


    sendRoute(mounted);
  };

  const navigate = useNavigate();


  return (
    <ApplicationLayout.Sidebar className="right z-index-2 height-100pct">
      <Sidebar
        title=""
        closed={false}
        onClose={() => {
          if (isEditTrip) {
            navigate("/routing/trips");
          } else {
            navigate("/routing/routes");
          }
        }}
        position={Sidebar.RIGHT}
        disableClose={false}
        width={580}
      >
        <div className="padding-left-20 padding-right-20 padding-bottom-20">
          <RegisterRouter
            handleCustom={handleCustom}
            isCustom={isCustom}
            onChangeRoutes={handleRoutes}
            onSave={handleSave}
            saveLabel={trip || isEditTrip ? 'Próximo' : 'Salvar rota'}
            trip={trip}
            isEditTrip={isEditTrip}
            handleEditDriverTrip={handleEditDriverTrip}
            handleEditVehicleTrip={handleEditVehicleTrip}
            skipChangeRoute={skipChangeRoute}
          // dataUpdateRoute={dataUpdateRoute}
          // setDataUpdateRoute={setDataUpdateRoute}
          />
          <Dialog.SaveName
            showDialog={showDialog}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            handleInputChange={handleInputChange}
            disableConfirm={disableConfirm}
            enableSubmit={enableSubmit}
          />
          {trip || isEditTrip ? (
            <div className="text-align-left">
              <span>
                <b>Atenção:</b>
                <span>
                  {" "}
                  Se você personalizar a rota selecionada, as alterações serão aplicadas exclusivamente para o seu uso,
                  sem afetar a rota principal.
                </span>
              </span>
            </div>
          ) : null}
        </div>
      </Sidebar>
    </ApplicationLayout.Sidebar>
  );
};

export default UpdateSidebarRoute;

